import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { MerchCardShadowColumns } from 'pricing-pages-ui-components/components/MerchCardShadowColumns';
import { HUBSPOT_CREDITS_CARDS_SECTION } from '../../../constants/tracking/TrackingSources';
import ProductAndServicesCatalogLink from '../../ProductAndServicesCatalogLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HubSpotCreditsColumnLayout = ({
  columns,
  isUngatedForInbound25,
  children,
  viewProps
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(PageSection, {
      hideOverflow: false,
      children: [/*#__PURE__*/_jsx(View, Object.assign({
        position: "relative",
        marginBlockEnd: "600"
      }, viewProps, {
        children: /*#__PURE__*/_jsx(MerchCardShadowColumns, {
          columns: columns,
          isUngatedForInbound25: isUngatedForInbound25,
          children: children
        })
      })), /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(ProductAndServicesCatalogLink, {
          trackingSource: HUBSPOT_CREDITS_CARDS_SECTION,
          section: "#HubSpotCreditsRateSheet",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.hubspot-credits.links.viewCreditsRateSheet"
          })
        })
      })]
    })
  });
};
export default HubSpotCreditsColumnLayout;